import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArbreComposant } from 'src/app/model/arbre/arbre-composant';
import { TreeService } from 'src/app/services/http/tree/tree.service';

@Component({
  selector: 'app-call-verifs',
  templateUrl: './call-verifs.component.html',
  styleUrls: ['./call-verifs.component.scss']
})
export class CallVerifsComponent implements OnInit {
 
/**
 * Root of components tree
 */
public rootOfTree!: ArbreComposant | undefined;
/**
 * Selected component in the tree
 */
public selectedComposant!: ArbreComposant;
/**
 * Current sub-tree being browsed
 */
public subTree: ArbreComposant[] = [];

@Input() snMachine!: string;

/** Evènement emis pour indiquer un changement du composant en cours */
@Output() composantEvent = new EventEmitter<ArbreComposant>(); 

@Output() resetMachine = new EventEmitter<boolean>(); 

constructor(private treeService : TreeService) { }

  async ngOnInit(): Promise<void> {
    /**
     * Set the machine (id = 1) as root of tree
     */
     this.rootOfTree = await this.treeService.getComposant(1);  
  }

  /**
   * Set the current selected component from the tree
   * Method bound to both the 'changeComposant' event (from current-verif) and the 'composantEvent' event (from arbre-composant)
   * @param composant an ArbreComposant[], being the subTree currently used
   */
  selectComposant( modifiedSubTree: ArbreComposant[] ){
    this.subTree = modifiedSubTree;
    this.treeService.resetSubTree();
    this.selectedComposant =  this.subTree[0];
    this.composantEvent.emit( this.selectedComposant );
  }

  async resetSelectedMachine(event: any){
    this.resetMachine.emit( true );
    this.rootOfTree = undefined;
    this.rootOfTree = await this.treeService.getComposant(1);  
  }

}
